import httpService from "./httpService";
import utils from "./utils";

export default {

  getListDocIn(pageable) {
    var params = utils.merge(
      pageable
    );
    return httpService.get("/dashboard/listDocIn", { params: params });
  },
  getListDocOut(pageable) {
    var params = utils.merge(
      pageable
    );
    return httpService.get("/dashboard/listDocOut", { params: params });
  },
  getCountDoc() {
    return httpService.get("/dashboard/countDoc");
  },

  getVbIncomingDocUserViews(pageable) {
    return httpService.get("/dashboard/getVbIncomingDocUserViews", { params: pageable });
  },

  getVbOutgoingDocUserViews(docStatuses, pageable) {
    let params = utils.merge(pageable, { docStatuses: docStatuses });
    return httpService.get("/dashboard/getVbIncomingDocUserViews", { params: params });
  },

  // Đang sử dụng
  getData(pageable) {
    var params = utils.merge(
      pageable
    );
    return httpService.get("/dashboard", { params: params });
  },

  getIncomingDocsDashBoard(pageable) {
    return httpService.get("/dashboard/getIncomingDocsDashBoard", { params: pageable });
  },

  getOutgoingDocsDashBoard(pageable) {
    return httpService.get("/dashboard/getOutgoingDocsDashBoard", { params: pageable });
  },

  getBanHanhOutgoingDocsDashBoard(pageable) {
    return httpService.get("/dashboard/getBanHanhOutgoingDocsDashBoard", { params: pageable });
  },

  getNotificationsDashBoard(pageable) {
    return httpService.get("/dashboard/getNotificationsDashBoard", { params: pageable });
  },
  getVanBanChoBanHanhDashBoard(pageable) {
    return httpService.get("/dashboard/getVanBanChoBanHanhDashBoard", { params: pageable });
  },

  getVanBanChoTiepNhanDashBoard(pageable) {
    return httpService.get("/dashboard/getVanBanChoTiepNhanDashBoard", { params: pageable });
  },

  getShareLibDocsDashBoard(pageable) {
    return httpService.get("/dashboard/getShareLibDocsDashBoard", { params: pageable });
  },

  // Lấy dữ liệu báo cáo phòng họp
  getMeetingRoomDashBoard(pageable) {
    return httpService.get("/dashboard/getPhongHopDashBoard", { params: pageable })
  },

  // Lấy dữ liệu báo cáo điều xe
  getDriverRequestDashBoard(pageable) {
    return httpService.get("/dashboard/getDieuXeDashBoard", { params: pageable })
  },

  // Lấy dữ liệu báo cáo lịch tuần
  getWeeklyScheduleDashboard(pageable) {
    return httpService.get("/dashboard/getLichTuanDashBoard", { params: pageable })
  },

  // Lấy thông tin báo cáo của văn thư
  getDashBoardVanThu() {
    return httpService.get("/dashboard/van-thu")
  },

  // Lấy thông tin công việc đã giao
  getDashBoardCongViecDagiao() {
    return httpService.get("/dashboard/cv-giao");
  },

  // Lấy thông tin công việc được giao
  getDashBoardCongViecDuocGiao() {
    return httpService.get("/dashboard/cv-duoc-giao");
  },
}



// WEBPACK FOOTER //
// ./src/services/dashBoardService.js